import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { clearProctorReturn, resolveRootTarget } from '@entities/olympiad'
import { useAuth } from '@shared/auth/authContext'
import { useMyProfileId } from '@shared/auth/useMyProfileId'
import { ROLES } from '@shared/config/constants'
import { Spinner } from '@shared/ui'

/**
 * Корень сайта.
 *
 * Раньше здесь стоял безусловный переход на логин — и этого хватало, пока на
 * корень никто не возвращался снаружи. Прокторинг возвращает: его
 * `PROCTOR_RETURN_URL` указывает сюда, и участник, только что писавший
 * олимпиаду, видел форму входа, хотя его сессия жива.
 *
 * Пока `AuthProvider` восстанавливает сессию, решать некуда: без этой паузы
 * вошедший участник успевал бы мигнуть логином.
 */
export function RootRedirect() {
  const { isAuthenticated, role, isLoading } = useAuth()
  const userId = useMyProfileId()

  // Контекст одноразовый: он отвечает на вопрос «куда вернуть участника
  // сейчас», а не «какую олимпиаду он смотрел». Без очистки любой заход на
  // корень до конца жизни вкладки уводил бы на ту же олимпиаду — хоть через
  // час после сдачи. Неавторизованного не трогаем: ему ещё предстоит войти,
  // и контекст нужен уже после входа.
  const isConsumed = !isLoading && isAuthenticated && role === ROLES.PARTICIPANT
  useEffect(() => {
    if (isConsumed) clearProctorReturn()
  }, [isConsumed])

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return <Navigate to={resolveRootTarget({ isAuthenticated, role, userId })} replace />
}
